import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Autosuggest from 'react-autosuggest';
import { selectAllUsers, clearUserList, userApi } from "../../reducers/userSlice";

const UserAutosuggest = ({user, onItemSelected, readOnly, style = {}}) => {
    const userLabel = (user) => {
        return user ? user.first_name+" "+user.last_name : ""
    }

    const [value, setValue] = useState( userLabel(user) )
    const items = useSelector( (state) => selectAllUsers(state) );
    const [forceSuggestion, setForceSuggestion] = useState(false);

    const dispatch = useDispatch();
    
    useEffect(()=>{
        setValue(userLabel(user))
    }, [user])

    useEffect(()=>{
        if(readOnly) {
            setValue("")
            setForceSuggestion(false)
        }
    }, [readOnly])

    const renderSuggestion = (suggestion) => (
        <div>
          {userLabel(suggestion)}
        </div>
    );

    const onChange = (event, { newValue, method }) => {
        setValue(newValue);
        if(onItemSelected) onItemSelected(null)
    };

    const suggestionOptions = {
        value: value,
        onChange: onChange,
        onKeyDown: ((event) => {
            if(event.keyCode === 40 && value === "") {
                dispatch( userApi.fetchAll({page: 0, term: "", sorting: {firstname: 'ASC', lastname: 'ASC'}}) );
                setForceSuggestion(true)
            } else {
                setForceSuggestion(false)
            }
        }),
        onDoubleClick: ((event) => {
            if(!readOnly) {
                dispatch( userApi.fetchAll({page: 0, term: value, sorting: {firstname: 'ASC', lastname: 'ASC'}}) );
                setForceSuggestion(true)
            }
        }),
        className: "form-control",
        placeholder: 'Type a user name',
        readOnly: readOnly,
        style: style
    }

    const containerProps = {
        // style: {position: 'absolute'}
    };

    const getSuggestionValue = (suggestion) => { 
        return userLabel(suggestion)
    };

    const onSuggestionsFetchRequested = (value ) => {
        setForceSuggestion(false)
        dispatch( userApi.fetchAll({page: 0, term: value, sorting: {firstname: 'ASC', lastname: 'ASC'}}) );
    };

    const onSuggestionsClearRequested = () => {
        setForceSuggestion(false)
        dispatch ( clearUserList() );
    };

    const onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        if(onItemSelected) onItemSelected(suggestion)
        dispatch ( clearUserList() );
    }

    const shouldRenderSuggestions = (value, reason) => {
        return (forceSuggestion || value.length > 0) && !readOnly
    }


    return (
        <Autosuggest 
            id={"user_autosuggest"}
            shouldRenderSuggestions={shouldRenderSuggestions}
            suggestions={items}
            onSuggestionsFetchRequested={({value}) => { onSuggestionsFetchRequested(value) }}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            onSuggestionSelected={onSuggestionSelected}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={suggestionOptions}
            containerProps={containerProps}
        />
    )
}

export default UserAutosuggest;